

$(document).on('click', '[href="#swym-wishlist"]', function(){
    window.location.href = 'https://fithome.es/pages/swym-share-wishlist';
    return false;
});

var akPageName = window.location.pathname.split("/").pop();
if(akPageName == 'swym-share-wishlist'){
    var wishlist = JSON.parse(localStorage.getItem('akWishlist')) || [];
    if(!wishlist.length){
        // window.location.href = "https://fithome.es/";
        var akHtml = `
            <style>
                .swym-ui-component.swym-shared-wishlist-page.swym-is-safari{
                    display: none;
                }
                .wishlist-empty-container{
                    display: flex;
                    align-items:center;
                    flex-direction: column;
                    gap: 5px;
                }
                .wishlist-empty {
                    max-width: 560px;
                    margin: 70px auto 120px;
                    padding: 50px 30px;
                    text-align: center;
                }

                .wishlist-empty__icon {
                    width: 72px;
                    height: 72px;
                    margin: 0 auto 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #e5e5e5;
                    border-radius: 50%;
                    color: #111;
                }

                .wishlist-empty__icon svg {
                    width: 34px;
                    height: 34px;
                }

                .wishlist-empty h2 {
                    margin: 0 0 14px;
                    font-size: 24px;
                    line-height: 1.3;
                    font-weight: 500;
                }

                .wishlist-empty p {
                    max-width: 420px;
                    margin: 0 auto 30px;
                    color: #666;
                    font-size: 15px;
                    line-height: 1.6;
                }

                .wishlist-empty__button {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 190px;
                    padding: 14px 28px;
                    background: #111;
                    color: #fff;
                    text-decoration: none;
                    font-size: 14px;
                    transition: opacity .2s ease;
                }

                .wishlist-empty__button:hover {
                    opacity: .8;
                }

                @media screen and (max-width: 749px) {
                    .wishlist-empty {
                        margin: 40px auto 80px;
                        padding: 35px 20px;
                    }

                    .wishlist-empty h2 {
                        font-size: 21px;
                    }

                    .wishlist-empty p {
                        font-size: 14px;
                    }
                }
            </style>
            <div class="wishlist-empty-container">
                <div class="wishlist-empty__icon" aria-hidden="true">
                    <svg viewBox="0 0 64 64" fill="none">
                        <path
                            d="M32 54S9 40.5 9 23.5C9 15.5 14.7 10 22 10c4.6 0 8.2 2.3 10 6 1.8-3.7 5.4-6 10-6 7.3 0 13 5.5 13 13.5C55 40.5 32 54 32 54Z"
                            stroke="currentColor"
                            stroke-width="2"
                        />
                    </svg>
                </div>

                <h2>Tu lista de deseos está vacía</h2>

                <p>
                    Guarda tus productos favoritos aquí para tenerlos siempre a mano.
                </p>

                <a href="/" class="wishlist-empty__button">
                    Descubrir productos
                </a>
            </div> 
        `;
        $(akHtml).insertAfter($('.main-page-title.page-title.h2.text-center.scroll-trigger.animate--fade-in'));
    }else{
        console.log("wishlist", wishlist);
        var akStyle = `
            <style>
            .card__media .media img{
                height: 100% !important;
            }
            body ul#product-grid{
                padding: 0;
            }
            #swym-shared-wishlist-render-container .product-count.light{
                display: flex;
                justify-content: flex-end;
            }
            #swym-shared-wishlist-render-container .ak-swym-add-to-wishlist-view-product{
                opacity: 1 !important;
            }
           
            .ak-swym-add-to-wishlist-view-product svg.zero{
                display: none !important;
            }
            body .ak-delete-all-btn{
                font-family: 'Manrope';
                font-style: normal;
                font-weight: 500;
                font-size: 12px;
                line-height: 24px;
            }
            body .ak-delete-all-btn svg{
                height: 12px;
                width: auto;
            }
            body .ak-delete-all-btn{
                display: flex;
                align-items: center;
                gap: 8px;
                margin-right: 19px;
                cursor: pointer;
            }
            body .ak-delete-all-btn span{
                margin-top: 2px;
            }
            @media screen and (max-width:767px){
                body .page-width{
                    padding: 0 !important;
                }
                ul#product-grid{
                    padding: 0 !important;
                }
                .product-count.light{
                    padding-right: 10px;
                }
            }
            #swym-shared-wishlist-render-container .swym-ui-component.swym-shared-wishlist-page.swym-is-safari{
                display: none !important;
            }
            </style>
        `;
        var akHtml = '';
        wishlist.forEach( (e, i) => {
            akHtml += '<li class="grid__item scroll-trigger animate--slide-in">';
            akHtml += e.akHtml;
            akHtml += '</li>';
            console.log(e, i)
        });
        var akFinalAkhtml = `
            ${akStyle}
            <div class="gradient color-background-1">
                <div class="product-grid-container scroll-trigger animate--slide-in" id="ProductGridContainer" data-cascade="">
                    <div class="collection page-width">
                        <div class="product-count light" role="status">
                            <h2 class="product-count__text text-body">
                                <div class="ak-delete-all-btn">
                                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 4H18L17.1245 17.133C17.0544 18.1836 16.1818 19 15.1289 19H6.87111C5.81818 19 4.94558 18.1836 4.87554 17.133L4 4Z" stroke="black" stroke-width="2"/>
                                    <path d="M8 4V1H14V4" stroke="black" stroke-width="2" stroke-linejoin="round"/>
                                    <path d="M2 4H20" stroke="black" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M9 8V15" stroke="black" stroke-width="2" stroke-linecap="round"/>
                                    <path d="M13 8V15" stroke="black" stroke-width="2" stroke-linecap="round"/>
                                    </svg>

                                    <span>${locale_delete_all_text}</span>
                                </div>
                                <div class="grid-icon grid-icon-action-container">
                                    <span class="svg-icon" data-column="3">
                                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.85366 19.1464V25H1V19.1464H6.85366Z" stroke="#BDBCB7"></path>
                                            <path d="M6.85366 1V6.85364H1V1H6.85366Z" stroke="#BDBCB7"></path>
                                            <path d="M6.85366 9.97552V15.8292H1V9.97552H6.85366Z" stroke="#BDBCB7"></path>
                                            <path d="M16.0245 19.1464V25H10.1708V19.1464H16.0245Z" stroke="#BDBCB7"></path>
                                            <path d="M16.0245 1V6.85364H10.1708V1H16.0245Z" stroke="#BDBCB7"></path>
                                            <path d="M16.0245 9.97552V15.8292H10.1708V9.97552H16.0245Z" stroke="#BDBCB7"></path>
                                            <path d="M25 19.1464V25H19.1464V19.1464H25Z" stroke="#BDBCB7"></path>
                                            <path d="M25 1V6.85364H19.1464V1H25Z" stroke="#BDBCB7"></path>
                                            <path d="M25 9.97552V15.8292H19.1464V9.97552H25Z" stroke="#BDBCB7"></path>
                                        </svg>
                                    </span>
                                    <span class="svg-icon activeSVG" data-column="2">
                                        <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 1H10.8824V10.4706H1V1ZM1 14.5294H10.8824V24H1V14.5294ZM15.1176 1H25V10.4706H15.1176V1ZM15.1176 14.5294H25V24H15.1176V14.5294Z" stroke="#BDBCB7" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                    <span class="svg-icon" data-column="1">
                                        <svg width="27" height="26" viewBox="0 0 27 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="1" width="10" height="24" stroke="#BDBCB7"></rect>
                                            <rect x="16" y="1" width="10" height="24" stroke="#BDBCB7"></rect>
                                        </svg>
                                    </span>
                                </div>
                            </h2>
                        </div>

                        <ul id="product-grid" class="grid product-grid grid--2-col-tablet-down grid--5-col-desktop " data-grid-column="4">
                            ${akHtml}
                        </ul>
                    </div>
                </div>
            </div>
        `;

        $('#swym-shared-wishlist-render-container').html(akFinalAkhtml);
        $('#MainContent .page-width--narrow').removeClass('page-width--narrow page-width');

        $(document).on('click', '#swym-shared-wishlist-render-container .ak-swym-add-to-wishlist-view-product', function(e){
            var akParent = $(e.target).parents('.grid__item');
            var akTargetUrl = akParent.find('.card__media a').attr('href');
        
            let wishlist = JSON.parse(localStorage.getItem('akWishlist')) || [];
            var index = wishlist.findIndex(item => item.url === akTargetUrl);
            if (index !== -1) {
                // Remove product from wishlist
                wishlist.splice(index, 1);
                localStorage.setItem('akWishlist', JSON.stringify(wishlist));
                location.reload();
            }
        });

        $(document).on('mouseup', '.ak-delete-all-btn', function(){
            var akc = confirm(`${locale_clear_wishlist_text}`);
            if(akc){
                localStorage.removeItem('akWishlist');
                window.location.reload();
            }
        });

        $(document).on('click', '.grid-icon-action-container span.svg-icon', function(){
            var akTargetColumns = $(this).data('column');
            $('#product-grid').attr('data-grid-column', akTargetColumns);
            console.log(akTargetColumns);
        });

        // var link = document.createElement('link');
        // link.rel = 'stylesheet';
        // link.type = 'text/css';
        // link.href = 'https://fithome.es/cdn/shop/t/23/assets/ak-custom.css?v=42112967546932916131759905942';
        // document.head.appendChild(link);

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://fithome.es/cdn/shop/t/23/assets/base.css?v=74733708882848952801761130741';
        document.head.appendChild(link);

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://fithome.es/cdn/shop/t/23/assets/component-card.css?v=42112967546932916131759905942';
        document.head.appendChild(link);

        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://fithome.es/cdn/shop/t/23/assets/custom-new.css?v=42112967546932916131759905942';
        document.head.appendChild(link);

    }
}else{
    // assign red heart for item already added to wishlist 
    let wishlist = JSON.parse(localStorage.getItem('akWishlist')); 
    console.log(wishlist);
    if(wishlist){
        wishlist.forEach(function(e, i){
            var thisUrl = e.url;
            var tmpTarget = $(`.card__media a[href='${thisUrl}']`).parents('.card-wrapper.product-card-wrapper').find('.ak-swym-add-to-wishlist-view-product');
            tmpTarget.addClass('ak-swym-add-to-wishlist-view-product-heart');
            tmpTarget.data('ak-swaction', "addedToWishlist") // data-ak-swaction="addToWishlist"
        });
    }

    $(document).on('click', function(e) {
        console.log("e.target", $(e.target).parent().data('ak-swaction'));
        if( $(e.target).data('ak-swaction') == 'addToWishlist' || $(e.target).parent().data('ak-swaction') == 'addToWishlist' ){
            var akParent = $(e.target).parents('.grid__item');
            
            $(e.target).parents(".card-wrapper").find(".ak-swym-add-to-wishlist-view-product").addClass('ak-swym-add-to-wishlist-view-product-heart');
            var product = {
                url: akParent.find('.card__media a').attr('href'),
                akHtml: akParent.html(),
            };
            console.log(product);
        
            let wishlist = JSON.parse(localStorage.getItem('akWishlist')) || [];
            var index = wishlist.findIndex(item => item.url === product.url);
            
            if (index === -1) {
                // Add product to wishlist
                wishlist.push(product);
                localStorage.setItem('akWishlist', JSON.stringify(wishlist));
            } else {
                // Remove product from wishlist
                wishlist.splice(index, 1);
                localStorage.setItem('akWishlist', JSON.stringify(wishlist));
            }
        }
    });

}

$(document).on('click', '.ak-swym-add-to-wishlist-view-product svg[class="one"]', function(e){
    console.log('red heart is clicked');
    var akParent = $(e.target).parents('.grid__item');
    var akTargetUrl = akParent.find('.card__media a').attr('href');

    let wishlist = JSON.parse(localStorage.getItem('akWishlist')) || [];
    var index = wishlist.findIndex(item => item.url === akTargetUrl);
    if (index !== -1) {
        // Remove product from wishlist
        wishlist.splice(index, 1);
        localStorage.setItem('akWishlist', JSON.stringify(wishlist));
        location.reload();
    }
});